import { render, staticRenderFns } from "./RewardSettingLayout.vue?vue&type=template&id=28ae7fb8&scoped=true"
import script from "./RewardSettingLayout.vue?vue&type=script&lang=js"
export * from "./RewardSettingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae7fb8",
  null
  
)

export default component.exports